var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../../core/runtime/src';
import { Modal } from '../../../modal/src';
import { BreadcrumbGroup } from '../../../breadcrumbs/src';
import { Button } from '../../../button/src';
import { Alert } from '../../../alert/src';
import { preventDefault } from '../helpers/prevent-default';
export var S3Modal = AwsUi.__addComponent('awsui-s3-modal', {
    releaseStatus: 'internal',
    properties: {
        visible: {
            type: 'boolean'
        },
        breadcrumbs: {
            type: 'array',
            itemTypes: ['BreadcrumbGroup.Item']
        },
        isSubmitEnabled: {
            type: 'boolean'
        },
        alert: {
            type: 'object',
            objectType: 'S3ResourceSelector.Alert'
        },
        onNavigate: {
            type: 'function',
            functionType: 'S3ResourceSelector.Navigate'
        },
        onSubmit: {
            type: 'function',
            functionType: 'S3ResourceSelector.Submit'
        },
        onModalDismiss: {
            type: 'function',
            functionType: 'S3ResourceSelector.ModalDismiss'
        },
        onAlertDismiss: {
            type: 'function',
            functionType: 'S3ResourceSelector.AlertDismiss'
        },
        i18nStrings: {
            type: 'object',
            objectType: 'S3ResourceSelector.I18nStrings'
        }
    },
    regions: {
        content: {
            isDefault: true
        }
    },
    callbacks: {
        initialized: function () { }
    },
    render: function (m, h) {
        var _a = this, visible = _a.visible, breadcrumbs = _a.breadcrumbs, isSubmitEnabled = _a.isSubmitEnabled, alert = _a.alert, onNavigate = _a.onNavigate, onSubmit = _a.onSubmit, onModalDismiss = _a.onModalDismiss, onAlertDismiss = _a.onAlertDismiss, i18nStrings = _a.i18nStrings;
        if (!i18nStrings) {
            return null;
        }
        // to make modal's visibility fully controlled
        var modalDismissPreventDefault = preventDefault(onModalDismiss);
        // to make alert's visibility fully controlled
        var alertDismissPreventDefault = preventDefault(onAlertDismiss);
        // to disable native browser navigation
        var navigatePreventDefault = preventDefault(onNavigate);
        return (AwsUi.__createElement(Modal, { className: "awsui-s3-modal", visible: visible, content: AwsUi.__createElement("div", { className: "awsui-s3-modal-content" },
                AwsUi.__createElement("div", { className: "awsui-util-mb-s" },
                    AwsUi.__createElement(BreadcrumbGroup, { label: i18nStrings.labelBreadcrumbs, items: breadcrumbs, click: navigatePreventDefault })),
                AwsUi.__createElement("div", { role: "alert", "aria-live": "assertive", "aria-atomic": "true" }, alert && (AwsUi.__createElement("div", { className: "awsui-util-mb-s" },
                    AwsUi.__createElement(Alert, __assign({}, alert, { dismissible: true, dismiss: alertDismissPreventDefault, dismissLabel: i18nStrings.labelAlertDismiss }))))),
                h.region('content')), header: i18nStrings.modalTitle, footer: AwsUi.__createElement("span", { className: "awsui-util-f-r" },
                AwsUi.__createElement(Button, { className: "awsui-s3-modal__cancel", variant: "link", text: i18nStrings.modalCancelButton, click: modalDismissPreventDefault, formAction: "none" }),
                AwsUi.__createElement(Button, { className: "awsui-s3-modal__submit", variant: "primary", disabled: !isSubmitEnabled, text: i18nStrings.modalSubmitButton, click: onSubmit, formAction: "none" })), expandToFit: true, dismiss: modalDismissPreventDefault, closeLabel: i18nStrings.labelModalDismiss, size: "max" }));
    }
});
//# sourceMappingURL=s3-modal.js.map